import { useLocation, useParams, useNavigate } from "react-router-dom";
import MainLayout from "../layoutpage/MainLayout";
import Footer from "../../components/Footer";

export default function PaymentSuccessPage() {
  const { bookingId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  if (!state || !state.booking) {
    return (
      <div className="container text-center mt-5">
        <h3>No payment data found.</h3>
      </div>
    );
  }

  const { booking, method, amount } = state;
console.log("booking method amount", booking, method, amount);
  return (
    <>

      <div className="container d-flex justify-content-center mt-5">
        <div className="shadow-lg p-5 rounded-4" style={{ maxWidth: 600 }}>
          
          <h2 className="text-success fw-bold text-center mb-3">
            Payment Successful!
          </h2>

          <p className="text-center text-secondary">
            Your payment has been successfully processed.
          </p>

          <hr />

          <h5 className="fw-bold mb-3">Payment Summary</h5>

          <p><strong>Booking ID:</strong> {booking.booking.id}</p>
          <p><strong>Name:</strong> {booking.booking.user.name}</p>
          <p><strong>Unit:</strong> {booking.booking.unit.unit_number}</p>
          <p><strong>Property:</strong> {booking.booking.property.name}</p>

          <hr />

          <p><strong>Payment Method:</strong> {method}</p>
          <p>
            <strong>Paid Amount:</strong>  
            <span className="text-success fw-bold"> ৳ {amount}</span>
          </p>
          <p>
            <strong>Total Paid:</strong>  
            <span className="fw-bold"> ৳ {booking.booking.paid_amount}</span>
          </p>
          <p>
            <strong>Due Now:</strong>  
            <span className="text-danger fw-bold"> ৳ {booking.booking.due_amount}</span>
          </p>

          <div className="text-center mt-4">
            <button
              className="btn btn-primary px-4 py-2"
              onClick={() => navigate("/properties_available/" + booking.booking.property.id)}
            >
              Back to Dashboard
            </button>
          </div>
        </div>
      </div>
     
    </>
  );
}
